/** Glosario ES → EN/PT/ZH/DE para contenido del menú (ingredientes, extras, etc.). */
export const MENU_CONNECTORS = {
  "en": {
    "de": "of",
    "del": "of the",
    "la": "the",
    "el": "the",
    "los": "the",
    "las": "the",
    "un": "a",
    "una": "a",
    "y": "and",
    "o": "or",
    "con": "with",
    "sin": "without",
    "para": "for",
    "en": "in",
    "al": "to the",
    "a": "to"
  },
  "pt": {
    "de": "de",
    "del": "do",
    "la": "a",
    "el": "o",
    "los": "os",
    "las": "as",
    "un": "um",
    "una": "uma",
    "y": "e",
    "o": "ou",
    "con": "com",
    "sin": "sem",
    "para": "para",
    "en": "em",
    "al": "ao",
    "a": "a"
  },
  "zh": {
    "de": "",
    "del": "",
    "la": "",
    "el": "",
    "los": "",
    "las": "",
    "un": "",
    "una": "",
    "y": "和",
    "o": "或",
    "con": "配",
    "sin": "不要",
    "para": "",
    "en": "",
    "al": "",
    "a": ""
  },
  "de": {
    "de": "von",
    "del": "des",
    "la": "die",
    "el": "der",
    "los": "die",
    "las": "die",
    "un": "ein",
    "una": "eine",
    "y": "und",
    "o": "oder",
    "con": "mit",
    "sin": "ohne",
    "para": "für",
    "en": "in",
    "al": "zum",
    "a": "zu"
  }
};

/** @type {Record<string, {en:string, pt:string, zh:string, de:string}>} */
export const MENU_CONTENT_GLOSSARY = {
  "ingredientes": {
    "en": "ingredients",
    "pt": "ingredientes",
    "zh": "配料",
    "de": "zutaten"
  },
  "extras": {
    "en": "extras",
    "pt": "extras",
    "zh": "加料",
    "de": "extras"
  },
  "agregados": {
    "en": "add-ons",
    "pt": "adicionais",
    "zh": "加料",
    "de": "zusätze"
  },
  "salsas": {
    "en": "sauces",
    "pt": "molhos",
    "zh": "酱料",
    "de": "saucen"
  },
  "salsa": {
    "en": "sauce",
    "pt": "molho",
    "zh": "酱",
    "de": "sauce"
  },
  "toppings": {
    "en": "toppings",
    "pt": "coberturas",
    "zh": "配料",
    "de": "beläge"
  },
  "acompanamientos": {
    "en": "sides",
    "pt": "acompanhamentos",
    "zh": "配菜",
    "de": "beilagen"
  },
  "acompanamiento": {
    "en": "side",
    "pt": "acompanhamento",
    "zh": "配菜",
    "de": "beilage"
  },
  "bebidas": {
    "en": "drinks",
    "pt": "bebidas",
    "zh": "饮品",
    "de": "getränke"
  },
  "bebida": {
    "en": "drink",
    "pt": "bebida",
    "zh": "饮品",
    "de": "getränk"
  },
  "guarnicion": {
    "en": "side dish",
    "pt": "guarnição",
    "zh": "配菜",
    "de": "beilage"
  },
  "guarniciones": {
    "en": "side dishes",
    "pt": "guarnições",
    "zh": "配菜",
    "de": "beilagen"
  },
  "cebolla": {
    "en": "onion",
    "pt": "cebola",
    "zh": "洋葱",
    "de": "zwiebel"
  },
  "cebolla morada": {
    "en": "red onion",
    "pt": "cebola roxa",
    "zh": "红洋葱",
    "de": "rote zwiebel"
  },
  "cebolla caramelizada": {
    "en": "caramelized onion",
    "pt": "cebola caramelizada",
    "zh": "焦糖洋葱",
    "de": "karamellisierte zwiebel"
  },
  "tomate": {
    "en": "tomato",
    "pt": "tomate",
    "zh": "番茄",
    "de": "tomate"
  },
  "tomates": {
    "en": "tomatoes",
    "pt": "tomates",
    "zh": "番茄",
    "de": "tomaten"
  },
  "lechuga": {
    "en": "lettuce",
    "pt": "alface",
    "zh": "生菜",
    "de": "salat"
  },
  "palta": {
    "en": "avocado",
    "pt": "abacate",
    "zh": "牛油果",
    "de": "avocado"
  },
  "aguacate": {
    "en": "avocado",
    "pt": "abacate",
    "zh": "牛油果",
    "de": "avocado"
  },
  "pepino": {
    "en": "cucumber",
    "pt": "pepino",
    "zh": "黄瓜",
    "de": "gurke"
  },
  "pimiento": {
    "en": "pepper",
    "pt": "pimentão",
    "zh": "甜椒",
    "de": "paprika"
  },
  "pimenton": {
    "en": "bell pepper",
    "pt": "pimentão",
    "zh": "甜椒",
    "de": "paprika"
  },
  "aji": {
    "en": "chili",
    "pt": "pimenta",
    "zh": "辣椒",
    "de": "chili"
  },
  "aji verde": {
    "en": "green chili",
    "pt": "pimenta verde",
    "zh": "青椒",
    "de": "grüne chili"
  },
  "jalapeno": {
    "en": "jalapeño",
    "pt": "jalapeño",
    "zh": "墨西哥辣椒",
    "de": "jalapeño"
  },
  "champinon": {
    "en": "mushroom",
    "pt": "cogumelo",
    "zh": "蘑菇",
    "de": "champignon"
  },
  "champinones": {
    "en": "mushrooms",
    "pt": "cogumelos",
    "zh": "蘑菇",
    "de": "champignons"
  },
  "hongos": {
    "en": "mushrooms",
    "pt": "cogumelos",
    "zh": "蘑菇",
    "de": "pilze"
  },
  "aceitunas": {
    "en": "olives",
    "pt": "azeitonas",
    "zh": "橄榄",
    "de": "oliven"
  },
  "aceituna": {
    "en": "olive",
    "pt": "azeitona",
    "zh": "橄榄",
    "de": "olive"
  },
  "rucula": {
    "en": "arugula",
    "pt": "rúcula",
    "zh": "芝麻菜",
    "de": "rucola"
  },
  "espinaca": {
    "en": "spinach",
    "pt": "espinafre",
    "zh": "菠菜",
    "de": "spinat"
  },
  "zanahoria": {
    "en": "carrot",
    "pt": "cenoura",
    "zh": "胡萝卜",
    "de": "karotte"
  },
  "repollo": {
    "en": "cabbage",
    "pt": "repolho",
    "zh": "卷心菜",
    "de": "kohl"
  },
  "col": {
    "en": "cabbage",
    "pt": "repolho",
    "zh": "卷心菜",
    "de": "kohl"
  },
  "brocoli": {
    "en": "broccoli",
    "pt": "brócolis",
    "zh": "西兰花",
    "de": "brokkoli"
  },
  "choclo": {
    "en": "corn",
    "pt": "milho",
    "zh": "玉米",
    "de": "mais"
  },
  "maiz": {
    "en": "corn",
    "pt": "milho",
    "zh": "玉米",
    "de": "mais"
  },
  "porotos verdes": {
    "en": "green beans",
    "pt": "vagem",
    "zh": "四季豆",
    "de": "grüne bohnen"
  },
  "alberjas": {
    "en": "peas",
    "pt": "ervilhas",
    "zh": "豌豆",
    "de": "erbsen"
  },
  "cilantro": {
    "en": "cilantro",
    "pt": "coentro",
    "zh": "香菜",
    "de": "koriander"
  },
  "perejil": {
    "en": "parsley",
    "pt": "salsa",
    "zh": "欧芹",
    "de": "petersilie"
  },
  "albahaca": {
    "en": "basil",
    "pt": "manjericão",
    "zh": "罗勒",
    "de": "basilikum"
  },
  "ajo": {
    "en": "garlic",
    "pt": "alho",
    "zh": "大蒜",
    "de": "knoblauch"
  },
  "jengibre": {
    "en": "ginger",
    "pt": "gengibre",
    "zh": "姜",
    "de": "ingwer"
  },
  "pollo": {
    "en": "chicken",
    "pt": "frango",
    "zh": "鸡肉",
    "de": "hähnchen"
  },
  "carne": {
    "en": "meat",
    "pt": "carne",
    "zh": "肉",
    "de": "fleisch"
  },
  "vacuno": {
    "en": "beef",
    "pt": "bovino",
    "zh": "牛肉",
    "de": "rindfleisch"
  },
  "res": {
    "en": "beef",
    "pt": "carne bovina",
    "zh": "牛肉",
    "de": "rind"
  },
  "cerdo": {
    "en": "pork",
    "pt": "porco",
    "zh": "猪肉",
    "de": "schwein"
  },
  "chorizo": {
    "en": "chorizo",
    "pt": "linguiça",
    "zh": "西班牙香肠",
    "de": "chorizo"
  },
  "longaniza": {
    "en": "sausage",
    "pt": "linguiça",
    "zh": "香肠",
    "de": "wurst"
  },
  "jamon": {
    "en": "ham",
    "pt": "presunto",
    "zh": "火腿",
    "de": "schinken"
  },
  "jamon serrano": {
    "en": "serrano ham",
    "pt": "presunto serrano",
    "zh": "塞拉诺火腿",
    "de": "serranoschinken"
  },
  "tocino": {
    "en": "bacon",
    "pt": "bacon",
    "zh": "培根",
    "de": "speck"
  },
  "bacon": {
    "en": "bacon",
    "pt": "bacon",
    "zh": "培根",
    "de": "speck"
  },
  "salame": {
    "en": "salami",
    "pt": "salame",
    "zh": "萨拉米",
    "de": "salami"
  },
  "pepperoni": {
    "en": "pepperoni",
    "pt": "pepperoni",
    "zh": "意式辣肠",
    "de": "pepperoni"
  },
  "atun": {
    "en": "tuna",
    "pt": "atum",
    "zh": "金枪鱼",
    "de": "thunfisch"
  },
  "salmon": {
    "en": "salmon",
    "pt": "salmão",
    "zh": "三文鱼",
    "de": "lachs"
  },
  "camaron": {
    "en": "shrimp",
    "pt": "camarão",
    "zh": "虾",
    "de": "garnele"
  },
  "camarones": {
    "en": "shrimp",
    "pt": "camarões",
    "zh": "虾",
    "de": "garnelen"
  },
  "mariscos": {
    "en": "seafood",
    "pt": "frutos do mar",
    "zh": "海鲜",
    "de": "meeresfrüchte"
  },
  "pescado": {
    "en": "fish",
    "pt": "peixe",
    "zh": "鱼",
    "de": "fisch"
  },
  "huevo": {
    "en": "egg",
    "pt": "ovo",
    "zh": "鸡蛋",
    "de": "ei"
  },
  "huevos": {
    "en": "eggs",
    "pt": "ovos",
    "zh": "鸡蛋",
    "de": "eier"
  },
  "huevo frito": {
    "en": "fried egg",
    "pt": "ovo frito",
    "zh": "煎蛋",
    "de": "spiegelei"
  },
  "tofu": {
    "en": "tofu",
    "pt": "tofu",
    "zh": "豆腐",
    "de": "tofu"
  },
  "churrasco": {
    "en": "grilled steak",
    "pt": "churrasco",
    "zh": "烤肉",
    "de": "grillsteak"
  },
  "mechada": {
    "en": "pulled beef",
    "pt": "carne desfiada",
    "zh": "手撕牛肉",
    "de": "zupfrind"
  },
  "carne mechada": {
    "en": "pulled beef",
    "pt": "carne desfiada",
    "zh": "手撕牛肉",
    "de": "zupfrind"
  },
  "lomo": {
    "en": "loin",
    "pt": "lombo",
    "zh": "里脊",
    "de": "lende"
  },
  "costillar": {
    "en": "ribs",
    "pt": "costela",
    "zh": "排骨",
    "de": "rippchen"
  },
  "alitas": {
    "en": "wings",
    "pt": "asinhas",
    "zh": "鸡翅",
    "de": "flügel"
  },
  "nuggets": {
    "en": "nuggets",
    "pt": "nuggets",
    "zh": "鸡块",
    "de": "nuggets"
  },
  "queso": {
    "en": "cheese",
    "pt": "queijo",
    "zh": "奶酪",
    "de": "käse"
  },
  "queso cheddar": {
    "en": "cheddar cheese",
    "pt": "queijo cheddar",
    "zh": "切达奶酪",
    "de": "cheddar"
  },
  "cheddar": {
    "en": "cheddar",
    "pt": "cheddar",
    "zh": "切达",
    "de": "cheddar"
  },
  "queso mozzarella": {
    "en": "mozzarella",
    "pt": "mussarela",
    "zh": "马苏里拉",
    "de": "mozzarella"
  },
  "mozzarella": {
    "en": "mozzarella",
    "pt": "mussarela",
    "zh": "马苏里拉",
    "de": "mozzarella"
  },
  "queso crema": {
    "en": "cream cheese",
    "pt": "cream cheese",
    "zh": "奶油奶酪",
    "de": "frischkäse"
  },
  "crema": {
    "en": "cream",
    "pt": "creme",
    "zh": "奶油",
    "de": "sahne"
  },
  "crema agria": {
    "en": "sour cream",
    "pt": "creme azedo",
    "zh": "酸奶油",
    "de": "sauerrahm"
  },
  "mantequilla": {
    "en": "butter",
    "pt": "manteiga",
    "zh": "黄油",
    "de": "butter"
  },
  "leche": {
    "en": "milk",
    "pt": "leite",
    "zh": "牛奶",
    "de": "milch"
  },
  "yogurt": {
    "en": "yogurt",
    "pt": "iogurte",
    "zh": "酸奶",
    "de": "joghurt"
  },
  "mayonnaise": {
    "en": "mayonnaise",
    "pt": "maionese",
    "zh": "蛋黄酱",
    "de": "mayonnaise"
  },
  "mayonesa": {
    "en": "mayonnaise",
    "pt": "maionese",
    "zh": "蛋黄酱",
    "de": "mayonnaise"
  },
  "mayo": {
    "en": "mayo",
    "pt": "maionese",
    "zh": "蛋黄酱",
    "de": "mayo"
  },
  "ketchup": {
    "en": "ketchup",
    "pt": "ketchup",
    "zh": "番茄酱",
    "de": "ketchup"
  },
  "mostaza": {
    "en": "mustard",
    "pt": "mostarda",
    "zh": "芥末",
    "de": "senf"
  },
  "bbq": {
    "en": "BBQ",
    "pt": "BBQ",
    "zh": "烧烤酱",
    "de": "BBQ"
  },
  "salsa bbq": {
    "en": "BBQ sauce",
    "pt": "molho BBQ",
    "zh": "烧烤酱",
    "de": "BBQ-sauce"
  },
  "salsa aji": {
    "en": "chili sauce",
    "pt": "molho de pimenta",
    "zh": "辣椒酱",
    "de": "chilisauce"
  },
  "salsa verde": {
    "en": "green sauce",
    "pt": "molho verde",
    "zh": "青酱",
    "de": "grüne sauce"
  },
  "salsa roja": {
    "en": "red sauce",
    "pt": "molho vermelho",
    "zh": "红酱",
    "de": "rote sauce"
  },
  "salsa de tomate": {
    "en": "tomato sauce",
    "pt": "molho de tomate",
    "zh": "番茄酱",
    "de": "tomatensauce"
  },
  "salsa de soya": {
    "en": "soy sauce",
    "pt": "molho de soja",
    "zh": "酱油",
    "de": "sojasauce"
  },
  "soya": {
    "en": "soy sauce",
    "pt": "shoyu",
    "zh": "酱油",
    "de": "sojasauce"
  },
  "teriyaki": {
    "en": "teriyaki",
    "pt": "teriyaki",
    "zh": "照烧",
    "de": "teriyaki"
  },
  "pesto": {
    "en": "pesto",
    "pt": "pesto",
    "zh": "青酱",
    "de": "pesto"
  },
  "guacamole": {
    "en": "guacamole",
    "pt": "guacamole",
    "zh": "牛油果酱",
    "de": "guacamole"
  },
  "hummus": {
    "en": "hummus",
    "pt": "homus",
    "zh": "鹰嘴豆泥",
    "de": "hummus"
  },
  "aji amarillo": {
    "en": "yellow chili",
    "pt": "pimenta amarela",
    "zh": "黄辣椒",
    "de": "gelbe chili"
  },
  "chimichurri": {
    "en": "chimichurri",
    "pt": "chimichurri",
    "zh": "青酱",
    "de": "chimichurri"
  },
  "vinagreta": {
    "en": "vinaigrette",
    "pt": "vinagrete",
    "zh": "油醋汁",
    "de": "vinaigrette"
  },
  "aceite de oliva": {
    "en": "olive oil",
    "pt": "azeite",
    "zh": "橄榄油",
    "de": "olivenöl"
  },
  "aceite": {
    "en": "oil",
    "pt": "óleo",
    "zh": "油",
    "de": "öl"
  },
  "sal": {
    "en": "salt",
    "pt": "sal",
    "zh": "盐",
    "de": "salz"
  },
  "pimienta": {
    "en": "pepper",
    "pt": "pimenta",
    "zh": "胡椒",
    "de": "pfeffer"
  },
  "azucar": {
    "en": "sugar",
    "pt": "açúcar",
    "zh": "糖",
    "de": "zucker"
  },
  "miel": {
    "en": "honey",
    "pt": "mel",
    "zh": "蜂蜜",
    "de": "honig"
  },
  "limon": {
    "en": "lemon",
    "pt": "limão",
    "zh": "柠檬",
    "de": "zitrone"
  },
  "lima": {
    "en": "lime",
    "pt": "lima",
    "zh": "青柠",
    "de": "limette"
  },
  "pan": {
    "en": "bread",
    "pt": "pão",
    "zh": "面包",
    "de": "brot"
  },
  "pan de hamburguesa": {
    "en": "burger bun",
    "pt": "pão de hambúrguer",
    "zh": "汉堡胚",
    "de": "burgerbrötchen"
  },
  "tortilla": {
    "en": "tortilla",
    "pt": "tortilha",
    "zh": "玉米饼",
    "de": "tortilla"
  },
  "arroz": {
    "en": "rice",
    "pt": "arroz",
    "zh": "米饭",
    "de": "reis"
  },
  "fideos": {
    "en": "noodles",
    "pt": "macarrão",
    "zh": "面条",
    "de": "nudeln"
  },
  "pasta": {
    "en": "pasta",
    "pt": "massa",
    "zh": "意面",
    "de": "pasta"
  },
  "papas": {
    "en": "fries",
    "pt": "batatas",
    "zh": "薯条",
    "de": "pommes"
  },
  "papas fritas": {
    "en": "french fries",
    "pt": "batata frita",
    "zh": "薯条",
    "de": "pommes frites"
  },
  "papas bravas": {
    "en": "patatas bravas",
    "pt": "batatas bravas",
    "zh": "西班牙辣土豆",
    "de": "patatas bravas"
  },
  "pure": {
    "en": "mashed potatoes",
    "pt": "purê",
    "zh": "土豆泥",
    "de": "kartoffelpüree"
  },
  "pure de papas": {
    "en": "mashed potatoes",
    "pt": "purê de batata",
    "zh": "土豆泥",
    "de": "kartoffelpüree"
  },
  "ensalada": {
    "en": "salad",
    "pt": "salada",
    "zh": "沙拉",
    "de": "salat"
  },
  "ensalada cesar": {
    "en": "caesar salad",
    "pt": "salada caesar",
    "zh": "凯撒沙拉",
    "de": "caesar salad"
  },
  "casera": {
    "en": "house-made",
    "pt": "caseira",
    "zh": "自制",
    "de": "hausgemacht"
  },
  "casero": {
    "en": "house-made",
    "pt": "caseiro",
    "zh": "自制",
    "de": "hausgemacht"
  },
  "hamburguesa": {
    "en": "burger",
    "pt": "hambúrguer",
    "zh": "汉堡",
    "de": "burger"
  },
  "hamburguesas": {
    "en": "burgers",
    "pt": "hambúrgueres",
    "zh": "汉堡",
    "de": "burger"
  },
  "pizza": {
    "en": "pizza",
    "pt": "pizza",
    "zh": "披萨",
    "de": "pizza"
  },
  "pizzas": {
    "en": "pizzas",
    "pt": "pizzas",
    "zh": "披萨",
    "de": "pizzen"
  },
  "completo": {
    "en": "chilean hot dog",
    "pt": "completo",
    "zh": "智利热狗",
    "de": "chilenischer hotdog"
  },
  "hot dog": {
    "en": "hot dog",
    "pt": "hot dog",
    "zh": "热狗",
    "de": "hotdog"
  },
  "sandwich": {
    "en": "sandwich",
    "pt": "sanduíche",
    "zh": "三明治",
    "de": "sandwich"
  },
  "sandwichs": {
    "en": "sandwiches",
    "pt": "sanduíches",
    "zh": "三明治",
    "de": "sandwiches"
  },
  "empanada": {
    "en": "empanada",
    "pt": "empada",
    "zh": "馅饼",
    "de": "empanada"
  },
  "empanadas": {
    "en": "empanadas",
    "pt": "empadas",
    "zh": "馅饼",
    "de": "empanadas"
  },
  "taco": {
    "en": "taco",
    "pt": "taco",
    "zh": "墨西哥卷",
    "de": "taco"
  },
  "tacos": {
    "en": "tacos",
    "pt": "tacos",
    "zh": "墨西哥卷",
    "de": "tacos"
  },
  "burrito": {
    "en": "burrito",
    "pt": "burrito",
    "zh": "墨西哥卷饼",
    "de": "burrito"
  },
  "sushi": {
    "en": "sushi",
    "pt": "sushi",
    "zh": "寿司",
    "de": "sushi"
  },
  "ramen": {
    "en": "ramen",
    "pt": "ramen",
    "zh": "拉面",
    "de": "ramen"
  },
  "poke": {
    "en": "poke",
    "pt": "poke",
    "zh": "波奇碗",
    "de": "poke"
  },
  "bowl": {
    "en": "bowl",
    "pt": "bowl",
    "zh": "盖饭",
    "de": "bowl"
  },
  "wrap": {
    "en": "wrap",
    "pt": "wrap",
    "zh": "卷饼",
    "de": "wrap"
  },
  "nugget": {
    "en": "nugget",
    "pt": "nugget",
    "zh": "鸡块",
    "de": "nugget"
  },
  "alitas de pollo": {
    "en": "chicken wings",
    "pt": "asinhas de frango",
    "zh": "鸡翅",
    "de": "hähnchenflügel"
  },
  "papas gajo": {
    "en": "potato wedges",
    "pt": "batata rústica",
    "zh": "楔形薯条",
    "de": "kartoffelspalten"
  },
  "onion rings": {
    "en": "onion rings",
    "pt": "onion rings",
    "zh": "洋葱圈",
    "de": "zwiebelringe"
  },
  "aros de cebolla": {
    "en": "onion rings",
    "pt": "anel de cebola",
    "zh": "洋葱圈",
    "de": "zwiebelringe"
  },
  "agua": {
    "en": "water",
    "pt": "água",
    "zh": "水",
    "de": "wasser"
  },
  "agua mineral": {
    "en": "mineral water",
    "pt": "água mineral",
    "zh": "矿泉水",
    "de": "mineralwasser"
  },
  "agua con gas": {
    "en": "sparkling water",
    "pt": "água com gás",
    "zh": "气泡水",
    "de": "sprudelwasser"
  },
  "jugo": {
    "en": "juice",
    "pt": "suco",
    "zh": "果汁",
    "de": "saft"
  },
  "jugos": {
    "en": "juices",
    "pt": "sucos",
    "zh": "果汁",
    "de": "säfte"
  },
  "limonada": {
    "en": "lemonade",
    "pt": "limonada",
    "zh": "柠檬水",
    "de": "limonade"
  },
  "cafe": {
    "en": "coffee",
    "pt": "café",
    "zh": "咖啡",
    "de": "kaffee"
  },
  "te": {
    "en": "tea",
    "pt": "chá",
    "zh": "茶",
    "de": "tee"
  },
  "cerveza": {
    "en": "beer",
    "pt": "cerveja",
    "zh": "啤酒",
    "de": "bier"
  },
  "vino": {
    "en": "wine",
    "pt": "vinho",
    "zh": "葡萄酒",
    "de": "wein"
  },
  "refresco": {
    "en": "soft drink",
    "pt": "refrigerante",
    "zh": "汽水",
    "de": "limonade"
  },
  "bebida gaseosa": {
    "en": "soda",
    "pt": "refrigerante",
    "zh": "汽水",
    "de": "limo"
  },
  "coca cola": {
    "en": "Coca-Cola",
    "pt": "Coca-Cola",
    "zh": "可口可乐",
    "de": "Coca-Cola"
  },
  "sprite": {
    "en": "Sprite",
    "pt": "Sprite",
    "zh": "雪碧",
    "de": "Sprite"
  },
  "fanta": {
    "en": "Fanta",
    "pt": "Fanta",
    "zh": "芬达",
    "de": "Fanta"
  },
  "shake": {
    "en": "shake",
    "pt": "shake",
    "zh": "奶昔",
    "de": "shake"
  },
  "milkshake": {
    "en": "milkshake",
    "pt": "milkshake",
    "zh": "奶昔",
    "de": "milkshake"
  },
  "smoothie": {
    "en": "smoothie",
    "pt": "smoothie",
    "zh": "冰沙",
    "de": "smoothie"
  },
  "frito": {
    "en": "fried",
    "pt": "frito",
    "zh": "油炸",
    "de": "frittiert"
  },
  "frita": {
    "en": "fried",
    "pt": "frita",
    "zh": "油炸",
    "de": "frittiert"
  },
  "fritas": {
    "en": "fried",
    "pt": "fritas",
    "zh": "油炸",
    "de": "frittiert"
  },
  "grillado": {
    "en": "grilled",
    "pt": "grelhado",
    "zh": "烤",
    "de": "gegrillt"
  },
  "grillada": {
    "en": "grilled",
    "pt": "grelhada",
    "zh": "烤",
    "de": "gegrillt"
  },
  "al horno": {
    "en": "baked",
    "pt": "ao forno",
    "zh": "烘烤",
    "de": "aus dem ofen"
  },
  "al vapor": {
    "en": "steamed",
    "pt": "no vapor",
    "zh": "蒸",
    "de": "gedämpft"
  },
  "crudo": {
    "en": "raw",
    "pt": "cru",
    "zh": "生的",
    "de": "roh"
  },
  "cocido": {
    "en": "cooked",
    "pt": "cozido",
    "zh": "煮熟",
    "de": "gekocht"
  },
  "ahumado": {
    "en": "smoked",
    "pt": "defumado",
    "zh": "烟熏",
    "de": "geräuchert"
  },
  "picante": {
    "en": "spicy",
    "pt": "picante",
    "zh": "辣",
    "de": "scharf"
  },
  "dulce": {
    "en": "sweet",
    "pt": "doce",
    "zh": "甜",
    "de": "süß"
  },
  "salado": {
    "en": "savory",
    "pt": "salgado",
    "zh": "咸",
    "de": "salzig"
  },
  "clasico": {
    "en": "classic",
    "pt": "clássico",
    "zh": "经典",
    "de": "klassisch"
  },
  "clasica": {
    "en": "classic",
    "pt": "clássica",
    "zh": "经典",
    "de": "klassisch"
  },
  "especial": {
    "en": "special",
    "pt": "especial",
    "zh": "特制",
    "de": "spezial"
  },
  "tradicional": {
    "en": "traditional",
    "pt": "tradicional",
    "zh": "传统",
    "de": "traditionell"
  },
  "grande": {
    "en": "large",
    "pt": "grande",
    "zh": "大份",
    "de": "groß"
  },
  "mediano": {
    "en": "medium",
    "pt": "médio",
    "zh": "中份",
    "de": "mittel"
  },
  "mediana": {
    "en": "medium",
    "pt": "média",
    "zh": "中份",
    "de": "mittel"
  },
  "pequeno": {
    "en": "small",
    "pt": "pequeno",
    "zh": "小份",
    "de": "klein"
  },
  "pequena": {
    "en": "small",
    "pt": "pequena",
    "zh": "小份",
    "de": "klein"
  },
  "familiar": {
    "en": "family size",
    "pt": "familiar",
    "zh": "家庭装",
    "de": "familiengröße"
  },
  "individual": {
    "en": "individual",
    "pt": "individual",
    "zh": "单人份",
    "de": "einzeln"
  },
  "porcion": {
    "en": "portion",
    "pt": "porção",
    "zh": "份",
    "de": "portion"
  },
  "porciones": {
    "en": "portions",
    "pt": "porções",
    "zh": "份",
    "de": "portionen"
  },
  "sin": {
    "en": "without",
    "pt": "sem",
    "zh": "不要",
    "de": "ohne"
  },
  "con": {
    "en": "with",
    "pt": "com",
    "zh": "加",
    "de": "mit"
  },
  "extra": {
    "en": "extra",
    "pt": "extra",
    "zh": "额外",
    "de": "extra"
  },
  "doble": {
    "en": "double",
    "pt": "duplo",
    "zh": "双份",
    "de": "doppelt"
  },
  "triple": {
    "en": "triple",
    "pt": "triplo",
    "zh": "三份",
    "de": "dreifach"
  },
  "gratis": {
    "en": "free",
    "pt": "grátis",
    "zh": "免费",
    "de": "gratis"
  },
  "incluido": {
    "en": "included",
    "pt": "incluído",
    "zh": "包含",
    "de": "enthalten"
  },
  "incluidos": {
    "en": "included",
    "pt": "incluídos",
    "zh": "包含",
    "de": "enthalten"
  },
  "recomendado": {
    "en": "recommended",
    "pt": "recomendado",
    "zh": "推荐",
    "de": "empfohlen"
  },
  "nuevo": {
    "en": "new",
    "pt": "novo",
    "zh": "新品",
    "de": "neu"
  },
  "nueva": {
    "en": "new",
    "pt": "nova",
    "zh": "新品",
    "de": "neu"
  },
  "gluten": {
    "en": "gluten",
    "pt": "glúten",
    "zh": "麸质",
    "de": "gluten"
  },
  "sin gluten": {
    "en": "gluten free",
    "pt": "sem glúten",
    "zh": "无麸质",
    "de": "glutenfrei"
  },
  "lacteos": {
    "en": "dairy",
    "pt": "laticínios",
    "zh": "乳制品",
    "de": "milchprodukte"
  },
  "sin lacteos": {
    "en": "dairy free",
    "pt": "sem lactose",
    "zh": "无乳制品",
    "de": "laktosefrei"
  },
  "frutos secos": {
    "en": "nuts",
    "pt": "oleaginosas",
    "zh": "坚果",
    "de": "schalenfrüchte"
  },
  "mani": {
    "en": "peanut",
    "pt": "amendoim",
    "zh": "花生",
    "de": "erdnuss"
  },
  "nueces": {
    "en": "walnuts",
    "pt": "nozes",
    "zh": "核桃",
    "de": "walnüsse"
  },
  "almendras": {
    "en": "almonds",
    "pt": "amêndoas",
    "zh": "杏仁",
    "de": "mandeln"
  },
  "sesamo": {
    "en": "sesame",
    "pt": "gergelim",
    "zh": "芝麻",
    "de": "sesam"
  },
  "soja": {
    "en": "soy",
    "pt": "soja",
    "zh": "大豆",
    "de": "soja"
  },
  "churrasco italiano": {
    "en": "italian steak sandwich",
    "pt": "churrasco italiano",
    "zh": "意式烤肉三明治",
    "de": "italienisches steak-sandwich"
  },
  "barros luco": {
    "en": "barros luco",
    "pt": "barros luco",
    "zh": "巴罗斯卢科三明治",
    "de": "barros luco"
  },
  "ave palta": {
    "en": "chicken avocado sandwich",
    "pt": "frango com abacate",
    "zh": "鸡肉牛油果三明治",
    "de": "hähnchen-avocado-sandwich"
  },
  "completo italiano": {
    "en": "italian completo",
    "pt": "completo italiano",
    "zh": "意式智利热狗",
    "de": "italienischer completo"
  },
  "completo dinamico": {
    "en": "dynamic completo",
    "pt": "completo dinâmico",
    "zh": "动态智利热狗",
    "de": "dynamischer completo"
  },
  "papas mayo": {
    "en": "fries with mayo",
    "pt": "batata com maionese",
    "zh": "薯条配蛋黄酱",
    "de": "pommes mit mayo"
  },
  "salsa golf": {
    "en": "golf sauce",
    "pt": "molho golf",
    "zh": "高尔夫酱",
    "de": "golfsauce"
  },
  "pebre": {
    "en": "pebre",
    "pt": "pebre",
    "zh": "智利香菜酱",
    "de": "pebre"
  },
  "merken": {
    "en": "merquén",
    "pt": "merquén",
    "zh": "智利辣椒粉",
    "de": "merquén"
  }
};

